import { Component, OnInit } from '@angular/core';
import { NavParams, ViewController, AlertController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { Subscription, Observable, Subscriber } from 'rxjs';
import { APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import { LogMessages, Activities, Logs } from 'api/collections';
import { Log, LogType, LogMessage, LogMessageType, Activity, Project } from 'api/models';
@Component({
  selector: 'show-picture',
  templateUrl: 'show-picture.html'
})
export class ShowPictureComponent implements OnInit {
  pictureSrc: string;
  captionText: string;
  logMessage: LogMessage;

  constructor(
    private _app: App,
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private alertCtrl: AlertController,
    public httpService: HttpService
  ) {
    this.pictureSrc = this.navParams.get('pictureSrc');
    this.viewCtrl = viewCtrl;
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  ngOnInit() {
  console.log('show picture page');
    // Get the log message in order to show the caption text
    const logMessageId = this.navParams.get('logMessageId');
    const autorun = MeteorObservable.autorun();
    // const subscription = MeteorObservable.subscribe('logMessage', logMessageId);
    const subscription = this.httpService.MeteorSubscribe('logMessage', logMessageId);
    Observable.merge(autorun, subscription).subscribe(() => {
      this.logMessage = LogMessages.findOne(logMessageId);
      this.captionText = this.logMessage && this.logMessage.captionText;
    });
  }
  showPhotoCaptionPrompt(logMessage: LogMessage, alertCtrl: AlertController) {
    const message = logMessage.captionText ? 'Edit photo caption' : 'Add a caption';
    let prompt = alertCtrl.create({
      title: 'Photo Caption',
      message: message,
      inputs: [
        {
          name: 'caption',
          placeholder: 'Caption...',
          value: logMessage.captionText,
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Save',
          handler: ({ caption }) => {
            this.httpService.MeteorCall('updateLogMessageCaptionText', logMessage._id, caption);
            LogMessages.update({_id: logMessage._id}, {$set: {captionText:caption}});
          }
        }
      ]
    });
    prompt.present();
  }

  goToEditCaption() {
    this.showPhotoCaptionPrompt(this.logMessage, this.alertCtrl);
  }

}



// WEBPACK FOOTER //
// ./src/pages/show-picture/show-picture.ts